import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTablerWorldWww = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.248 6.40002C19.3418 5.0437 18.1145 3.93233 16.6752 3.16471C15.2359 2.39708 13.6292 1.99699 11.998 2.00002C10.3696 1.99892 8.76615 2.39998 7.33 3.16756C5.89386 3.93514 4.66949 5.0455 3.76562 6.40002",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.448 2C10.5908 3.37353 9.91566 4.85257 9.43943 6.4M12.548 2C13.406 3.37342 14.0819 4.85246 14.5588 6.4M20.248 17.4C19.3418 18.7563 18.1145 19.8677 16.6752 20.6353C15.2359 21.4029 13.6292 21.803 11.998 21.8C10.3696 21.8011 8.76615 21.4 7.33 20.6325C5.89386 19.8649 4.66949 18.7545 3.76562 17.4",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.45 21.7992C10.5928 20.4257 9.91763 18.9467 9.4414 17.3992M12.55 21.7992C13.408 20.4258 14.0839 18.9468 14.5608 17.3992M1 9.69922L2.1 14.0992L3.75 9.69922L5.4 14.0992L6.5 9.69922M17.5 9.69922L18.6 14.0992L20.25 9.69922L21.9 14.0992L23 9.69922M9.25 9.69922L10.35 14.0992L12 9.69922L13.65 14.0992L14.75 9.69922",
			stroke: "black",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgTablerWorldWww;
